import * as React from 'react'

function getSnapshot() {
  return window.location.href
}
//initial value for server, won't build if you dont use getServerSnapshot
function getServerSnapshot() {
  return ''
}
function subscribe(callback: () => void) {
  const handleLocationChange = () => callback()
  const handleLocationChangeTimeout = () => setTimeout(handleLocationChange, 5000)

  window.addEventListener('popstate', handleLocationChange)
  window.addEventListener('hashchange', handleLocationChange)
  // Used for client-side navigation
  window.addEventListener('cf-popstate', handleLocationChangeTimeout)

  return () => {
    window.removeEventListener('popstate', handleLocationChange)
    window.removeEventListener('hashchange', handleLocationChange)
    window.removeEventListener('cf-popstate', handleLocationChangeTimeout)
  }
}

// Custom hook to track `window.location.href`
export function useCurrentUrl() {
  return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
